








































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import MainButton from '@/main-components/common/MainButton.vue';
import { getAffiliateCode, getToken } from '@/utils/cookie';
import { axios } from '@/utils/axios';
import { Coupon } from '@/resource/coupon/coupon.model';
import AffliateCopy from '@/main-components/affiliate/AffliateCopy.vue';
import ModalRegister2 from '@/main-components/common/modal/ModalRegister2.vue';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

async function generateCoupon(): Promise<Coupon | null> {
  try {
    const { data } = await axios.put(`users/coupon`);
    return data;
  } catch (error) {
    return null;
  }
}

@Component({
  components: {
    MainButton,
    AffliateCopy,
    ModalRegister2,
  },
  metaInfo(this: Affiliate): MetaInfo {
    return {
      title: pageSEO.title.affiliate,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.affiliate,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.affiliate,
          description: pageSEO.description.affiliate,
        }),
      ],
    };
  },
})
export default class Affiliate extends Vue {
  get affiliateCodeCookie() {
    return getAffiliateCode();
  }

  get isLoggedin() {
    return getToken() ? true : false;
  }

  get showAffiliateCopy() {
    if (this.isLoading) {
      return true;
    } else if (this.affiliateCode) {
      return true;
    } else if (!this.affiliateCode) {
      return false;
    } else {
      return false;
    }
  }

  affiliateCode = '';
  isLoading = true;

  async created() {
    if (this.isLoggedin) {
      if (this.affiliateCodeCookie) {
        this.affiliateCode = this.affiliateCodeCookie;
      } else {
        const coupon = await generateCoupon();

        if (coupon) {
          this.affiliateCode = coupon.name;
        } else {
          this.affiliateCode = '';
        }
      }
    }

    this.isLoading = false;

    this.$sendMpEvent({
      event: this.$mp_value.JoinAffiliateView,
    });
  }

  reviewArrays = [
    [
      {
        id: 1,
        picture: 1,
        name: 'Rafizzi',
        money: 'RM 340',
        comment:
          'alhamdulillah banyak duit yang saya dapat buat. Senang je, promote je mysoalan dekat kawan2 untuk langgan, mereka pun tak complain sebab mmg website ni banyak soalan',
      },
      {
        id: 4,
        picture: 4,
        name: 'Amelia',
        money: 'RM 290',
        comment:
          'Sejujurnya mula-mula nak jadi affiliate, saya takde la nak percaya sangat tapi lepas diorang transfer RM50 haritu lepas saya suruh kawan-kawan subscribe, memang saya sangat recommend orang lain untuk jadi affiliate',
      },
      {
        id: 3,
        picture: 3,
        name: 'Aaliyaafiqah06',
        money: 'RM 710',
        comment:
          'Sistem program affiliate ini sangat mudah untuk difahami dan dibuat. Kalau ada apa-apa soalan, whatsapp je team mysoalan, mereka akan explain. Sangat praktikal!',
      },
    ],
    [
      {
        id: 2,
        picture: 2,
        name: 'Aanurzizie',
        money: 'RM 480',
        comment:
          'Saya amat happy dengan program affiliate ini. Dengan hanya mengajak individu lain untuk melanggan, kita boleh menerima 10 ringgit setiap orang. Ini adalah peluang yang baik untuk menambah pendapatan sampingan.',
      },
      {
        id: 5,
        picture: 5,
        name: 'Addeena',
        money: 'RM 80',
        comment:
          'Saya student, tak sangka boleh buat duit semudah ini. Tak payah buat kerja berat2 just kena rajin untuk promote MySoalan dekat orang lain',
      },
      {
        id: 6,
        picture: 6,
        name: 'Abatrisyia',
        money: 'RM 110',
        comment:
          'Saya amat teruja dengan potensi pendapatan tanpa had melalui program affiliate ini. Semakin banyak orang yang saya ajak, semakin banyak yang saya terima.',
      },
    ],
    [
      {
        id: 3,
        picture: 3,
        name: 'Aaliyaafiqah06',
        money: 'RM 710',
        comment:
          'Sistem program affiliate ini sangat mudah untuk difahami dan dibuat. Kalau ada apa-apa soalan, whatsapp je team mysoalan, mereka akan explain. Sangat praktikal!',
      },
      {
        id: 6,
        picture: 6,
        name: 'Abatrisyia',
        money: 'RM 110',
        comment:
          'Saya amat teruja dengan potensi pendapatan tanpa had melalui program affiliate ini. Semakin banyak orang yang saya ajak, semakin banyak yang saya terima.',
      },
    ],
  ];

  getReviewImage(index: number) {
    return require('@/assets/image/img_avatar_' + index + '.png');
  }

  // joinAffiliateClick() {
  //   this.$sendMpEvent({
  //     event: this.$mp_value.JoinAffiliateClick,
  //   });

  //   window.open('https://wa.link/3blqiy', '_blank');
  // }

  showRegister = false;

  closeRegister() {
    this.showRegister = false;
  }

  openRegisterModal() {
    this.$sendMpEvent({
      event: this.$mp_value.JoinAffiliateClick,
    });

    this.showRegister = true;
  }
}
